import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ec675bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box_license" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createTextVNode(" 请保存您的license。当前窗口关闭后，无法再次查询license。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 如果您遗失了这个license，可以创建新的来替代。 ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationCircleOutlined = _resolveComponent("ExclamationCircleOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_CopyOutlined = _resolveComponent("CopyOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_form, {
          ref: "form",
          class: "box_form",
          model: $data.form.data,
          rules: $data.form.rule,
          labelAlign: "right",
          labelCol: {span:3}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { name: "code" }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  title: "申请码请安装软件后，点击订阅获取"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createTextVNode(" 申请码 "),
                      _createVNode(_component_ExclamationCircleOutlined, { class: "tip" })
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: $data.form.data.code,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($data.form.data.code) = $event)),
                  placeholder: "请输入申请码",
                  autoSize: {minRows:6,maxRows:10},
                  maxlength: 1000,
                  showCount: "",
                  allowClear: ""
                }, null, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              label: "申请人",
              name: "applicant"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  class: "input",
                  value: $data.form.data.applicant,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($data.form.data.applicant) = $event)),
                  placeholder: "请输入申请人的姓名",
                  maxlength: 100,
                  allowClear: ""
                }, null, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              label: "公司/学校",
              name: "company"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  class: "input",
                  value: $data.form.data.company,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($data.form.data.company) = $event)),
                  placeholder: "请输入公司/学校的全称",
                  maxlength: 100,
                  allowClear: ""
                }, null, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              label: "邀请码",
              name: "invite"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  class: "input",
                  value: $data.form.data.invite,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($data.form.data.invite) = $event)),
                  placeholder: "邀请码",
                  maxlength: 100,
                  allowClear: ""
                }, null, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              label: "版本",
              name: "category"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $data.form.data.category,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($data.form.data.category) = $event)),
                  "button-style": "solid"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.enumType.LicenseTypeDict, (v) => {
                      return (_openBlock(), _createBlock(_component_a_radio_button, {
                        value: v.value,
                        disabled: v.expand?.disabled
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(v.label), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "disabled"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              label: "产品",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $data.form.data.name,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($data.form.data.name) = $event)),
                  "button-style": "solid",
                  onChange: _cache[6] || (_cache[6] = ($event: any) => ($options.getLicenseInfo()))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.enumType.LicenseNameDist, (v) => {
                      return (_openBlock(), _createBlock(_component_a_radio_button, {
                        value: v.value,
                        disabled: v.expand?.disabled
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(v.label), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "disabled"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              label: "成员数",
              name: "member"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $data.form.data.member,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($data.form.data.member) = $event)),
                  "button-style": "solid"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.request.data.member, (v) => {
                      return (_openBlock(), _createBlock(_component_a_radio_button, { value: v }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(v), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              label: "应用数",
              name: "app"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $data.form.data.app,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (($data.form.data.app) = $event)),
                  "button-style": "solid"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.request.data.app, (v) => {
                      return (_openBlock(), _createBlock(_component_a_radio_button, { value: v }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(v), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              label: "购买时长（月）",
              name: "expire"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: $data.form.data.expire,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (($data.form.data.expire) = $event)),
                  "button-style": "solid"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.request.data.expire, (v) => {
                      return (_openBlock(), _createBlock(_component_a_radio_button, { value: v }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(v), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["value"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              label: "订单金额（元）",
              name: "money"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($data.form.data.money), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_a_form_item, {
              wrapperCol: {offset:_ctx.$FN.Agent.client()==='PC'?3:0},
              class: "box_button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.clickBuy()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 立即购买 ")
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["wrapperCol"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["model", "rules"])
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: $data.modal.license,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (($data.modal.license) = $event)),
      title: "购买成功",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tag, {
          class: "box_tag",
          color: "warning"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, { size: 5 }, {
              default: _withCtx(() => [
                _createVNode(_component_ExclamationCircleOutlined),
                _hoisted_3
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_a_form, {
          class: "box_form_modal",
          labelAlign: "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "许可证",
              name: "license",
              class: "no_margin"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($data.form.data.license) + " ", 1 /* TEXT */),
                _createVNode(_component_a_button, {
                  type: "link",
                  size: "small",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$FN.CopyClipboard($data.form.data.license)))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_CopyOutlined)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" 复制 ")
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"])
  ], 64 /* STABLE_FRAGMENT */))
}